<template>
    <div>
        <div :class="sideBySide ? 'icard-container side-by-side' : 'icard-container stacked'"
            v-for="(stud_data, ind) in icard_data" :key="ind">
            <div style="width: 19rem;">
                <div class="row" style="background-color: 6237ee; height: 120px;">
                    <div class="col-1" style="margin-top: -5px; margin-left: -12px;">
                        <img :src="common_data.logo" style="width: 80px; height: 80px;margin-left: 10px" alt="logo" />
                    </div>
                    <div class="col-11" style="margin-top: -10px; margin-left: 10px;">
                        <center>
                            <span style="font-size: 11px; font-family: 'Roboto Condensed'; color: #331e69;"><b>{{
                                common_data.heading }}</b></span>
                            <div style="border-bottom: 1px solid white; width: 75%; margin-bottom: -5px;"></div>
                            <b>
                                <div v-if="common_data.org_id == 1"
                                    style="text-transform: uppercase; line-height: 1; color: #331e69; font-family: 'Vogue'; font-size: 12px;">
                                    VISHWAKARMA VIDYALAYA & JUNIOR COLLEGE (ENGLISH MEDIUM)
                                </div>
                                <div v-else
                                    style="text-transform: uppercase; line-height: 1; color: #331e69; font-family: 'Vogue'; font-size: 12px;">
                                    VISHWAKARMA VIDYALAYA & JUNIOR COLLEGE (MARATHI MEDIUM)
                                </div>
                            </b>
                        </center>
                        <strong>
                            <div v-if="common_data.org_id == 1"
                                style="margin-left: 45px; color: black; color: #331e69; font-size: x-small; font-family: 'Roboto Condensed';">
                                {{ common_data.school_address }} | 9156286954 | 9156291049
                            </div>
                            <div v-else
                                style="margin-left: 45px; color: black; color: #331e69; font-size: x-small; font-family: 'Roboto Condensed';">
                                {{ common_data.school_address }} | 7219102472 | 9561344854
                            </div>
                            <center>
                                <span
                                    style="color: black; font-size: 12px; color: #331e69; font-family: 'Roboto Condensed';">{{
                                        common_data.website }}</span>
                            </center>
                        </strong>
                    </div>
                </div>
                <div class="row"
                    style="background-color: black; height: 1.5px; width: 350px; justify-content: center; margin-left: -15px; margin-top: -20px;">
                </div>
                <div class="row ml-4"
                    style="justify-content: center; align-items: center; margin-top: 3px; margin-bottom: 3px;"
                    v-if="stud_data.icard_temp.child_photo">
                    <img style="border: 1.5px solid black; margin-right: 2px;"
                        v-if="stud_data.icard_temp.child_photo.field_value"
                        :src="stud_data.icard_temp.child_photo.field_value" width="120px" height="120px" />
                    <span
                        style="transform: rotate(-90deg); margin-top: 5px; margin-left: -20px; color: #623e7e; font-size: 14px; font-weight: bold;">
                        {{ common_data.ay }}
                    </span>
                </div>
                <div class="row" style="background-color: #1976d2; height: 25px; justify-content: center;">
                    <h3 style="color: white;">
                        <span v-if="stud_data.icard_temp.firstname">
                            {{ stud_data.icard_temp.firstname.field_value }}
                        </span>
                        <span v-if="stud_data.icard_temp.middlename">
                            {{ stud_data.icard_temp.middlename.field_value }}
                        </span>
                        <span v-if="stud_data.icard_temp.lastname">
                            {{ stud_data.icard_temp.lastname.field_value }}
                        </span>
                    </h3>
                </div>
                <div style="position: relative;">
                    <div class="row"
                        style="justify-content: center; margin-top: -10px; height: 200px; font-size: small; margin-left: 20px;">
                        <div class="col-6"><strong> Std.: </strong>{{ stud_data.icard_temp.std }}</div>
                        <div class="col-6"><strong> Div.: </strong>{{ stud_data.icard_temp.div }}</div>

                        <!-- <strong> PRN No.: </strong>{{ stud_data.icard_temp.grno }} -->
                        <div class="col-12" style="margin-top: -20px;">
                            <!-- <strong> PRN No.: </strong>{{ stud_data.icard_temp.grno }} -->
                            <strong> PRN No.: </strong>{{ stud_data.icard_temp.grno }}
                            <span class="pl-4"></span>
                            <strong> DOB: </strong>{{ stud_data.icard_temp.stud_dob }}
                        </div>

                        <div v-if="stud_data.icard_temp.address_for_icard" class="col-12"
                            style="margin-top: -20px; padding-right: 29px; text-align: justify;">
                            <strong> Address: </strong>{{ stud_data.icard_temp.address_for_icard.field_value }}
                        </div>
                        <div v-if="stud_data.icard_temp.emergency_contact_number" class="col-12"
                            style="margin-top: -20px;">
                            <strong> Emergency Contact No.: </strong>{{
                                stud_data.icard_temp.emergency_contact_number.field_value }}
                        </div>
                        <center>
                            <qrcode-vue style="margin-left: -20px;" :value="stud_data.icard_temp.grno"
                                :size="55"></qrcode-vue>
                        </center>
                    </div>
                    <div class="col-12" style="margin-top: -70px; margin-left: 220px;">
                        <img :src="common_data.sign" alt="Principal's Signature" style="width: 70px; height: 40px;" />
                        <br />
                        <strong> Principal</strong>
                    </div>
                </div>
                <div class="row" style="background-color: #1976d2; height: 20px; position: relative; margin-top: -6px;">
                </div>
            </div>
            <div class="pagebreak" style="height: 482px;width: 19rem">
                <div class="row" style="height: 120px;">
                    <div class="col-1" style="margin-top: -5px; margin-left: -12px;">
                        <img :src="common_data.logo" style="width: 80px; height: 80px;margin-left: 10px;" alt="logo" />
                    </div>
                    <div class="col-11" style="margin-top: -10px; margin-left: 10px;">
                        <center>
                            <span style="font-size: 11px; font-family: 'Roboto Condensed'; color: #331e69;"><b>{{
                                common_data.heading }}</b></span>
                            <div style="border-bottom: 1px solid white; width: 75%; margin-bottom: -5px;"></div>
                            <b>
                                <div v-if="common_data.org_id == 1"
                                    style="text-transform: uppercase; line-height: 1; color: #331e69; font-family: 'Vogue'; font-size: 12px;">
                                    VISHWAKARMA VIDYALAYA & JUNIOR COLLEGE (ENGLISH MEDIUM)
                                </div>
                                <div v-else
                                    style="text-transform: uppercase; line-height: 1; color: #331e69; font-family: 'Vogue'; font-size: 12px;">
                                    VISHWAKARMA VIDYALAYA & JUNIOR COLLEGE (MARATHI MEDIUM)
                                </div>
                            </b>
                        </center>
                        <strong>
                            <div v-if="common_data.org_id == 1"
                                style="margin-left: 45px; color: black; color: #331e69; font-size: x-small; font-family: 'Roboto Condensed';">
                                {{ common_data.school_address }} | 9156286954 | 9156291049
                            </div>
                            <div v-else
                                style="margin-left: 45px; color: black; color: #331e69; font-size: x-small; font-family: 'Roboto Condensed';">
                                {{ common_data.school_address }} | 7219102472 | 9561344854
                            </div>
                            <center>
                                <span
                                    style="color: black; font-size: 12px; color: #331e69; font-family: 'Roboto Condensed';">{{
                                        common_data.website }}</span>
                            </center>
                        </strong>
                    </div>
                </div>
                <div class="row"
                    style="background-color: black; height: 1.5px; width: 350px; justify-content: center; margin-left: -15px; margin-top: -20px;">
                </div>
                <div class="row" style="justify-content: center; margin-top: 40px;">
                    <span style="font-weight: 500;"> Parent Details</span>
                </div>
                <div class="row" style="justify-content: center; margin-top: 20px;">
                    <div style="margin-right: 15px; width: 6rem;">
                        <span style="position: relative;" v-if="stud_data.icard_temp.father_photo.field_value">
                            <center>
                                <span v-if="stud_data.icard_temp.father_photo.field_value"
                                    style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                                <img style="border: 1.5px solid black;"
                                    v-if="stud_data.icard_temp.father_photo.field_value"
                                    :src="stud_data.icard_temp.father_photo.field_value" width="100px" height="100px" />
                                <span v-if="stud_data.icard_temp.father_photo.field_value"
                                    style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 2.4px; right: -10%;"></span>
                            </center>
                        </span>
                        <span style="position: relative;" v-else>
                            <center>
                                <span
                                    style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                                <img style="border: 1.5px solid black;" alt=""
                                    :src="stud_data.icard_temp.father_photo.field_value" width="100px" height="100px" />
                                <span
                                    style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 2.4px; right: -10%;"></span>
                            </center>
                        </span>
                        <span v-if="stud_data.icard_temp.father_full_name" class="text-center">
                            <h5 style="color: #623e7e; height: 50px; font-size: 11px; line-height: 12px;">
                                {{ stud_data.icard_temp.father_full_name.field_value }}
                            </h5>
                        </span>
                        <div class="text-center" style="" v-if="stud_data.icard_temp.father_mobile_no">
                            <h5>
                                <span style="font-weight: 500;"> Contact No. : </span><br />
                                {{ stud_data.icard_temp.father_mobile_no.field_value }}
                            </h5>
                        </div>
                    </div>
                    <div style="border-right: #623e7e 1.5px dotted; margin-right: 15px; width: 1rem;"></div>
                    <div style="width: 6rem; margin-left: 15px;">
                        <span style="position: relative;" v-if="stud_data.icard_temp.mother_photo.field_value">
                            <center>
                                <span v-if="stud_data.icard_temp.mother_photo.field_value"
                                    style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                                <img style="border: 1.5px solid black;"
                                    v-if="stud_data.icard_temp.mother_photo.field_value"
                                    :src="stud_data.icard_temp.mother_photo.field_value" width="100px" height="100px" />
                                <span v-if="stud_data.icard_temp.mother_photo.field_value"
                                    style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 2.4px; right: -10%;"></span>
                            </center>
                        </span>
                        <span style="position: relative;" v-else>
                            <center>
                                <span
                                    style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                                <img style="border: 1.5px solid black;"
                                    :src="stud_data.icard_temp.mother_photo.field_value" alt="" width="100px"
                                    height="100px" />
                                <span
                                    style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 2.4px; right: -10%;"></span>
                            </center>
                        </span>
                        <span v-if="stud_data.icard_temp.mother_first_name" class="text-center">
                            <h5 style="color: #623e7e; height: 50px; font-size: 12px; line-height: 12px;">
                                {{ stud_data.icard_temp.mother_first_name.field_value }}
                            </h5>
                        </span>
                        <div class="text-center" v-if="stud_data.icard_temp.mother_mobile_no">
                            <h5>
                                <span style="font-weight: 500;"> Contact No. : </span><br />
                                {{ stud_data.icard_temp.mother_mobile_no.field_value }}
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="row" style="background-color: #1976d2; height: 25px; position: relative; top: 75px;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
        sideBySide: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        barcode: VueBarcode,
        QrcodeVue,
    },
    data: () => ({
        comp_load: false,
        stud_list: null,
        radios: null,
        stud_data: null,
        child_data: null,
        icard_data: [],
        std: null,
        div: null,
        common_data: null,
        status: null,
        prn: null,
    }),
    mounted() {
        this.prn = JSON.parse(localStorage.getItem("prn"));
        this.onload();
    },

    methods: {
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        onload() {
            const data = {
                learners: this.prn,
            };
            axios
                .post("/Icard/getIcardSpecificStudents", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.icard_data = res.data.icard_data
                        this.common_data = res.data.common_data
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>

<style scoped>
.icard-container.side-by-side {
    display: flex;
    flex-direction: row;
    gap: 50px;
}

.icard-container.stacked {
    display: flex;
    flex-direction: column;
}
@media (max-width: 600px) {
  .icard-container.side-by-side {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
}
@media print {

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .pagebreak {
        page-break-before: always !important;
        height: 200px;
    }

    @page {
        margin: 0;
        size: 54mm 85mm;
    }
}
</style>
